/**
 * Created by spepa on 25.05.2023
 */

const TestPlatform = function () {
    Platform.call(this, connector.TEST, {
        sdk: SdkManager.SDK_TEST
    });

    connector.social.needWindowForLogin = true;

    this.needsCountry = true;
};

TestPlatform.prototype = Object.create(Platform.prototype);
TestPlatform.prototype.constructor = TestPlatform;

TestPlatform.prototype.loadData = function () {
    return new Promise((resolve) => {
        setTimeout(() => {
            let data = localStorage.getItem(`${connector.config.projectId}_testStorage`);

            if (data) {
                data = JSON.parse(data);
            }

            resolve(data);
        }, 100);
    });
};

TestPlatform.prototype.setData = function () {
    return new Promise((resolve) => {
        localStorage.setItem(`${connector.config.projectId}_testStorage`, JSON.stringify(connector._platformStorage.data));

        resolve();
    });
};

TestPlatform.prototype.gameplayStart = function () {
    console.log("Game play start");
};

TestPlatform.prototype.gameplayStop = function () {
    console.log("Game play stop");
};

TestPlatform.prototype.getLocalStoragePrefix = function () {
    return "_test";
};

TestPlatform.prototype.canPassPayload = function () {
    return true;
};

TestPlatform.prototype.switchGame = function (url, payload) {
    if (payload) {
        url = connector.utils.addSearchParams(url, payload);
    }
    connector.platform.openUrl(url);
};

TestPlatform.prototype.canSwitchGame = function () {
    return true;
};
